// extracted by mini-css-extract-plugin
module.exports = {"ctaTitle":"editPaymentMethod_ctaTitle__JXWrd","editCta":"editPaymentMethod_editCta__f7EA9","paymentStyling":"editPaymentMethod_paymentStyling__pBCYD"};